// extracted by mini-css-extract-plugin
export default {"general":"GeneratedExam_general__LaIgP","ataTitle":"GeneratedExam_ataTitle__FUYRP"};